import * as Sentry from '@sentry/react';
import { promise as initializeSentryPromise } from '~/datadogRum/entryPoint';

window.wistiaInitQueue ||= [];

const withVisitorKey = (callback) => {
  window.wistiaInitQueue.push((wistia) => {
    Wistia.visitorKey.ready().then(() => {
      callback(wistia.visitorKey.value());
    });
  });
};

// Registration form contact_visitor_key
const wistiaVisitorKeyField = document.querySelector('#user_contact_visitor_key');

if (wistiaVisitorKeyField) {
  withVisitorKey((visitorKey) => {
    if (visitorKey) {
      wistiaVisitorKeyField.value = visitorKey;
    }
  });
}

// OAuthButtons
const googleLink = document.querySelector('#google_oauth');
const microsoftLink = document.querySelector('#microsoft_oauth');

const { standalone } = window.navigator;
const userAgent = window.navigator.userAgent.toLowerCase();
// This check includes chromuim browsers because they still contain "Safari" in the UA
const includesSafari = /safari/.test(userAgent);
const ios = /iphone|ipod|ipad/.test(userAgent);

if (ios) {
  if (!standalone && !includesSafari) {
    googleLink.style.display = 'none';
  }
} else if (userAgent.includes('wv')) {
  googleLink.style.display = 'none';
} else {
  // no-op
}

withVisitorKey((visitorKey) => {
  [googleLink, microsoftLink]
    .filter((link) => link)
    .forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.append('contact_visitor_key', visitorKey);
      link.href = url.href;
    });
});

// This is a list of referrers which we already know use window.open
// and don't need to log sentry errors.
const knownReferrers = [
  'wistia.com',
  'benchmark.wistia.com',
  'krikyabangladesh.wistia.com',
  'drjtgiudice.wistia.com',
  'ezmax.wistia.com',
  'nifs.wistia.com',
  'knime.wistia.com',
  'alere.wistia.com',
  'cbiz.wistia.com',
];

const isNoisyReferrer = (referrer) => {
  try {
    return knownReferrers.indexOf(new URL(referrer).host) !== -1;
  } catch (_e) {
    return false;
  }
};

// This is to report any window.opener issues. We want to eventually set
// Cross-Origin-Opener-Policy to same-origin but doing so breaks hootsuite
// and perhaps others. We need to log what URLs are opening up the login
// page as an opener so we can add them to some sort of allowlist for URLs
// that are actually safe.
if (window.opener) {
  let urlOfOpener;

  try {
    urlOfOpener = window.opener.location.href;
  } catch (_error) {
    urlOfOpener = 'unknown';
  }

  if (urlOfOpener !== 'unknown' || !isNoisyReferrer(document.referrer)) {
    initializeSentryPromise.then(() => {
      console.log(`window.opener used at: ${urlOfOpener}`);
      Sentry.setContext('windowOpener', { url: urlOfOpener, referrer: document.referrer });
      Sentry.captureMessage('window.opener used for login entrypoint', 'info');
    });
  }
}
